import React from 'react'
import PropTypes from 'prop-types'

const VideosList = props => {
  const getEntryCoachName = entry => {
    let coach = entry.plan.coaches[0]
    return `${coach.firstName} ${coach.lastName}`
  }

  return (
    <ul className='entries'>
      {props.entries.map((entry, idx) => {
        // Use idx instead of entry.id because some playlists have duplicate entries
        return (
          <li key={idx}>
            <a
              href={entry.buildEntryUrl({
                type: props.type,
                playlistUUID: props.playlistUUID
              })}
            >
              <div className='entry-image'>
                <img src={entry.videoThumbnail} />
                <span className='duration-label'>{entry.humanDuration}</span>
                {props.playlistPos === idx ? (
                  <React.Fragment>
                    <span className='glyphicon glyphicon-play' />
                    <span className='overlay' />
                  </React.Fragment>
                ) : null}
              </div>
              <div className='entry-information'>
                <h4 className='entry-plan'>
                  {props.showPlanTitle ? entry.plan.title : null}
                </h4>
                <h1 className='entry-title'>{entry.title}</h1>
                <h4 className='entry-coach'>{getEntryCoachName(entry)}</h4>
              </div>
            </a>
          </li>
        )
      })}
    </ul>
  )
}

VideosList.propTypes = {
  entries: PropTypes.array,
  playlistPos: PropTypes.number,
  playlistUUID: PropTypes.string,
  showPlanTitle: PropTypes.bool,
  type: PropTypes.string
}

export default VideosList
